import React from "react";
import '../css/custom.css';
const gif = require("../img/Loading-animation.gif");


const Loading = () => {

    return (
        <div className="loading"><img src={gif} alt="Loading..." /></div>
    )
}

export default Loading